import {
  AccountCircle,
  Help,
  HighlightOff,
  Logout,
  Notifications,
  Settings,
} from "@mui/icons-material";
import {
  Autocomplete,
  Backdrop,
  Button,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeNav } from "../../../components/hooks/trigger";
import PersonIcon from "@mui/icons-material/Person";
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import * as yup from "yup";
import { setSnackbar } from "../../../components/hooks/snackBar/reducers";
import { useFormik } from "formik";
const AccountDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [outletOpen , setOutletOpen] = useState(false)
  const [outlet, setOutlet] = useState([])
  const outletId = localStorage.getItem("outlet_id");
  const roleId = localStorage.getItem("role_id")
  const validationSchema = yup.object({
    outlet : yup.object().required()
  })
  const formik = useFormik({
    initialValues:{
      outlet:null
    },
    validationSchema: validationSchema,
    onSubmit:handleSave
  })
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOutlet = () => {
    setOutletOpen(true)
    setAnchorEl(null);
  }
  const handleClose = () => {
    setAnchorEl(null);
    // localStorage.removeItem("token")
    axios.post('/v1/users/logout').then(res=>{
      localStorage.clear();
    navigate("/login");
    dispatch(closeNav());
    }).catch(err=>{
      console.log(err)
    })
    
  };
  const handleCloseSessions =() => {
    axios.get(`/v1/users/clear/sessions`)
    .then((res) => {console.log(res)})
    .catch((err) => {console.log(err)})
  }
  const handleCloseOutlet = () => {
    setOutletOpen(false)
  }
  function handleSave(){
    if(formik.values.outlet !=null){
      localStorage.setItem('outlet_name' , formik.values.outlet.fullname)
      localStorage.setItem('outlet_id', formik.values.outlet.id)
      setOutletOpen(false)
      dispatch(setSnackbar(true , 'success' , "Outlet Switched Successfully"))
      window.location.reload()
    }
  }
  function getRoles(){
    axios.get('v1/users/info/1')
    .then(res=>{
      console.log(res.data)
      setOutlet(res.data.outlets)
      // localStorage.setItem('user_id', res.data.id)
      // const user_data ={
      //   user_name : res.data.user_name,
      //   mobile : res.data.user_mobile,
      //   email : res.data.user_email,
      //   user_type : res.data.user_type
      // }
      // localStorage.setItem('user_data', user_data)
    })
  }
  useEffect(() => {
    getRoles()
  },[])
  console.log(roleId == 2 || roleId == 1 ? "hai" : "bye")
  console.log(formik.values.outlet !=null && formik.values.outlet.fullname)
  // useEffect(() => {
  //   const handleResize = () => {
  //     // Update the state to show/hide AccountDetails based on the screen width
  //     setShowAccountDetails(window.innerWidth < 900);
  //   };

  //   // Attach the event listener when the component mounts
  //   window.addEventListener('resize', handleResize);

  //   // Call the handleResize function once to set the initial state
  //   handleResize();

  //   // Cleanup the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);
  return (
    <Fragment>
      <IconButton
        onClick={handleClick}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <AccountCircle sx={{ fontSize: 30 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuList dense sx={{ padding: 0 }}>
          {/* {showAccountDetails &&  <> */}
          <MenuItem>
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            {/* {outletId ? `Outlet ${outletName}` : "Warehouse"} */}
            Account
          </MenuItem>
          {outletId &&
                    <MenuItem onClick={() => handleOutlet()}>
                    <ListItemIcon>
                      <Help fontSize="small" />
                    </ListItemIcon>
                    Switch Outlet
                  </MenuItem>
          }
          {/* <MenuItem>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Switch Roles
          </MenuItem> */}
          {roleId == 2 || roleId == 1 ?
          <MenuItem onClick={() => handleCloseSessions()}>
            <ListItemIcon>
              <HighlightOff fontSize="small" />
            </ListItemIcon>
            Clear Sessions
          </MenuItem> : null
          
          }
          
          <MenuItem onClick={() => handleClose()}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
      <Backdrop open={outletOpen} sx={{zIndex : 9999}}>
        <Grid className="p-3 bg-white w-1/4 h-fit relative">
        <Typography fontWeight={600} variant="h6">Choose Outlet</Typography>

          <IconButton sx={{position : 'absolute', right:0, top : 0}} onClick={handleCloseOutlet}>
            <CloseIcon />
          </IconButton>
               
                 <Autocomplete 
                id="outlet"
                sx={{marginBlock: 1}}
                options={outlet}
                size="small"
                disableClearable
                value={formik.values.outlet}
                autoComplete={false}
                getOptionLabel={option => option.fullname}
                isOptionEqualToValue={(option, value)=> option.id === value.id}
                // onChange={(e, value)=>{
                //   console.log(e , value)
                //   localStorage.setItem('outlet_name' , value.fullname)
                //   localStorage.setItem('outlet_id', value.id)
                // }}
                onChange={(e,value) => {
                  formik.setFieldValue("outlet" , value)
                }}
                
                renderInput={(params)=>(
                  <TextField 
                  {...params}
                  placeholder="Select Outlet"
                  helperText={formik.touched.outlet && formik.errors.outlet}
                error={
                  formik.touched.outlet && Boolean(formik.errors.outlet)
                }
                  />
                )}
                />
                <Grid className="text-end">
                <Button variant="contained" onClick={formik.handleSubmit}>Save</Button>
                </Grid>
        </Grid>
      </Backdrop>
    </Fragment>
  );
};

export default memo(AccountDetails);
